/**
 * A mapping of key to view name.
 * The separated views used in mobile.
 * @type {Object}
 */
const VIEWS_NAME = {
  HOME: 'home',
  TRAINING: 'training',
  STORE: 'store',
  SEARCH: 'search',
  NEW: 'new',
  NOTIFICATIONS: 'notifications',
  PROFILE: 'profile'
}

/**
 * The domain name.
 * @type {string}
 */
const VIEWS_DOMAIN = 'views'
/**
 * The initial state.
 * @type {Object}
 */
const VIEWS_STATE = {
  active: null,
  /**
   * A mapping of view name to object.
   * @type {Object}
   */
  ...Object.values(VIEWS_NAME).reduce((obj, view) => {
    obj[view] = {
      locations: []
    }
    return obj
  }, {})
}

/**
 * A mapping of key to path.
 * @type {Object}
 */
const VIEWS_PATH = {
  ACTIVE: `${VIEWS_DOMAIN}.active`
}

export {
  VIEWS_DOMAIN,
  VIEWS_STATE,
  VIEWS_PATH,
  VIEWS_NAME
}
